<template>
  <div class="choose-reason">
    <z-fix-top
      keep-position
      class="fixtop"
      :style="{background: `${hideBackground ? 'transparent' : '#F7F7F7'}`}"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          @click-left="handleClickLeft"
          @click-right="handleGoToMyReport"
      >
       <span slot="right">
          我的举报
        <z-info :info="count != '0'" type="text" />
        </span>
      </z-nav-bar>
    </z-fix-top>
    <div class="flexcontainer" ref="scrollContainer" @scroll.passive="judgeScroll">
    <!--引导区域-->
      <div class="guide-tip">
        <div class="guide-tip-title">一起守护二手交易环境</div>
        <div class="guide-tip-count" v-html="disposedCount">
        </div>
        <div class="guide-tip-text">转转致⼒于为您提供更有品质的⼆⼿商品，我们承诺将第⼀时间响应举报和提供处置⽅案</div>
        <div class="guide-tip-swipe">
          <!-- 轮播图 -->
          <z-swipe :autoplay="3000" :width="170" :height="24" vertical :show-indicators="false">
            <z-swipe-item v-for="(item,index) in swipeList" :key="index">
              <img :src="item[0]" alt="">
              <span>{{item[1]}}</span>
            </z-swipe-item>
          </z-swipe>
        </div>
      </div>

      <!--内容区域-->
      <div class="content-container">
        <!--举报类型选择区域-->
        <div class="reason">
          <div class="reason-tip">请选择举报类型</div>
          <div class="reason-cell-container" v-for="(item,index) in this.reasonList"
            :key="index">
            <reason-cell
            :cellList="item"
            @cellClick="firstReasonClick"
          >
          </reason-cell>
          </div>
        </div>
      </div>

      <!-- 常见问题 -->
      <div class="choose-reason-related" ref="scrollTarget">
        <div class="title">常见问题</div>
        <z-collapse v-model="activeNames" @change="handleScroll" :border="false">
          <z-collapse-item :title="item.question" :name="index" v-for="(item,index) in relatedQuestions" :key="index" :border="false">
            {{item.answer}}
            <z-icon slot="right-icon" v-if="activeNames.includes(index)" name="https://pic5.zhuanstatic.com/zhuanzh/ce7c4175-284c-4a13-970d-cea4608dc278.png"></z-icon>
            <z-icon slot="right-icon" v-else name="https://pic5.zhuanstatic.com/zhuanzh/aa0c8d66-9cd9-4aab-ae27-eb5f9d61aeed.png"></z-icon>
          </z-collapse-item>
        </z-collapse>
      </div>
    </div>
    <!--二级三级原因-->
    <z-popup @closed="handleModalClose" v-model="showPopUp" position="bottom" :close-on-click-overlay="true">
      <div class="pop-header">
        <z-icon size="20px" @click="handlePrevReason" v-if="(curReason.level == 2 && curReason.isLeaf == false) || curReason.level > 2" class-prefix="zziconfont" name="arrow-left" class="popup-icon-left"></z-icon>
        <!-- flex布局占位元素 -->
        <span :style="{width:'12px'}" v-else></span>

        <span class="pop-header-title">{{curReason.reason}}</span>
        <z-icon size="17px" @click="closePopup" class-prefix="zziconfont" name="close-text-o" class="popup-icon-right"></z-icon>
      </div>
      <reason-cell v-if="showOtherReasonCell" :cellList="curReasonList" @cellClick="otherReasonClick"></reason-cell>
      <!-- <z-button-group>
        <z-button v-show="curReason.isLeaf" type="primary" @click="nextStep">确定</z-button>
      </z-button-group> -->
    </z-popup>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Popup, Dialog, Icon, NavBar, Info, Collapse, CollapseItem, Swipe, SwipeItem, FixTop } from '@zz-common/zz-ui';
import { lego } from '@zz-common/lego'
//此组件为复用组件，一级原因，其他原因都用这个
import ReasonCell from './ReasonCell/index.vue'
import { getantispamresult, getnoticeandshow, hastradingorder, getunreadcount } from '@api/resourceApi'
import { getCookie } from '../../../lib/utils'
import { findParentReason } from '../logic'

export default {
  name: 'ChooseReason',
  data() {
    return {
      hasTradingOrder: false, //是否有交易中的订单
      evidenceChoose: '', //证据选择
      showPopUp: false, //其他原因弹框显隐
      showOtherReasonCell: false, //其他原因组件显隐
      curReasonList: [], //当前列表
      curReason: {}, //当前原因
      noticeAndShow: {}, //轮播信息
      activeNames: [0], //collapse组件参数
      firstReason: {}, //记录那个以及原因，方便回溯
      hideBackground: true, //是否穿透顶部栏
      count: 0 //未读数量
    }
  },
  inject:
  {
    sharedData: {
      default: () => {}
    },
    submitData: {
      default: () => {}
    },
    setNavTitle: {
      default: () => {}
    },
    mergeSubmitData: {},
    setRadioChooseEvidence: {}
  },
  components: {
    'z-popup': Popup,
    'z-icon': Icon,
    'reason-cell': ReasonCell,
    'z-nav-bar': NavBar,
    'z-collapse': Collapse,
    'z-collapse-item': CollapseItem,
    'z-swipe': Swipe,
    'z-swipe-item': SwipeItem,
    'z-fix-top': FixTop,
    'z-info': Info
  },
  computed: {
    //一级原因列表
    reasonList() {
      return this.sharedData.reasonList
    },
    //相关问题
    relatedQuestions() {
      return this.noticeAndShow.notice ? JSON.parse(this.noticeAndShow.notice) : []
    },
    //已处理的数量
    disposedCount() {
      const text = this.noticeAndShow?.count?.count || ''
      const number = /\d+/.exec(text) ? /\d+/.exec(text)[0] : '-'
      return `${text.split(number)[0] || ''}<span class="guide-tip-count-num">${number}</span>${text.split(number)[1] || ''}`
    },
    //轮播图数据
    swipeList() {
      return this.noticeAndShow?.uidmap ? Object.entries(this.noticeAndShow?.uidmap) : []
    }
  },
  methods: {
    // //登出
    // logout() {
    //   this.fetchLoading = true
    //   return imUserLogout({
    //     uid: getCookie('uid'),
    //     source: '21'
    //   })
    //     .then((res) => {
    //       this.fetchLoading = false
    //       return res
    //     })
    //     .catch((err) => {
    //       this.fetchLoading = false
    //       console.error(err)
    //       if (!err.errMsg) return
    //       this.showToast(err.errMsg)
    //     })
    // },
    //非一级原因选择
    otherReasonClick(item) {
      console.log('cellclick', item)
      this.curReason = item
      if (item.reasonList.length) {
        this.curReasonList = item.reasonList
      }
      console.log('打印当前curreasonlist', this.curReasonList)
      if (item.isLeaf == true) {
        this.nextStep()
      }
    },
    //一级原因选择
    firstReasonClick(item) {
      console.log('cellclick', item)
      this.firstReason = item
      this.curReason = item
      //等于2走欺诈流程
      if (item.reasonId == '2') {
        lego.send({
          pagetype: 'ZZUP_REPORT_REASON',
          actiontype: 'CLICK_FRAUD',
          backup: {
            from: this.sharedData.from,
            uid: getCookie('uid')
          }
        })
        this.mergeSubmitData({
          reasonId: item.reasonId
        })
        this.setRadioChooseEvidence(item.evidenceChoose)
        if (this.hasTradingOrder) {
          this.$router.push('/reportreason/beforefraud')
        } else {
          this.$router.push('/reportreason/fraud')
        }
        return
      }
      //有子原因选择子原因
      if (item.reasonList.length) {
        this.curReasonList = item.reasonList
        this.showPopUp = true
        this.showOtherReasonCell = true
      } else {
        //没有走下一步
        this.nextStep()
      }
    },
    //返回上一级原因
    handlePrevReason() {
      this.curReason = findParentReason(this.firstReason, this.curReasonList)
      this.curReasonList = this.curReason.reasonList
    },
    //监听modal关闭事件
    handleModalClose() {
      this.showOtherReasonCell = false
    },
    //下一步
    nextStep() {
      //来源为11，9，7直接提交凭证
      if (['7', '9', '11'].includes(this.sharedData.from)) {
        this.mergeSubmitData({
          reasonId: this.curReason.reasonId
        })
        this.showPopUp = false
        console.log('关闭了吗', this.showPopUp)
        this.$router.push('/reportreason/commit')
        return
      }
      this.mergeSubmitData({
        reasonId: this.curReason.reasonId
      })
      this.setRadioChooseEvidence(this.curReason.evidenceChoose)
      this.showPopUp = false
      this.$router.push('/reportreason/chooseevidence')
    },
    //加载轮播图数据和处理数据还有未读数据
    async loadNoticeAndShow() {
      //轮播图和处理数量
      const res = await getnoticeandshow({ from: this.sharedData.from })
      this.noticeAndShow = res
      //未读数据
      const count = await getunreadcount()
      this.count = count.count
    },
    handleScroll(names) {
      this.activeNames = names
      setTimeout(() => { this.$refs.scrollTarget.scrollIntoView() }, 300)
    },
    judgeScroll() {
      if (this.$refs.scrollContainer.scrollTop >= 30) {
        this.hideBackground = false
      } else {
        this.hideBackground = true
      }
    },
    handleClickLeft() {
      native.close()
    },
    // 我的举报按钮触发
    handleGoToMyReport() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/reportlist?needHideHead=3',
        needClose: '0'
      })
    },
    closePopup() {
      this.showPopUp = false
    }
  },
  mounted() {
    lego.send({
      pagetype: 'ZZUP_REPORT_REASON',
      actiontype: 'PAGE_SHOW',
      backup: {
        from: this.sharedData.from
      }
    })
    //是否禁止举报
    getantispamresult({
      type: this.sharedData.from,
      toUid: this.sharedData.toUid,
      infoId: this.sharedData.infoId,
      videoId: this.sharedData.videoId,
      subOp: '10', // 举报原因页阻止弹窗subOp=10
      opType: '47'
    }).then((res) => {
      if (res.result === 'HIT') {
        Dialog({
          // title: '标题',
          message: res.message || '不能举报'
          // closeOnClickOverlay: true
        }).then(() => {
          native.close()
        })
      }
    })
    this.loadNoticeAndShow()
    hastradingorder({
      toUid: this.sharedData.toUid
    }).then(res => {
      if (res == 1) {
        this.hasTradingOrder = true
      }
    })
  },
  activated() {
    console.log('首次是否激活')
    this.showPopUp = false
    this.hideBackground = true
  },
  deactivated() {
    this.setNavTitle('举报')
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
